import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LazyLoadEvent } from 'primeng/api';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-wallethistory',
  templateUrl: './wallethistory.component.html',
  styleUrls: ['./wallethistory.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WallethistoryComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  public walletlist: any = [];
  public downloadwalletlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  searchby;
  searchBy: any[];
  username: string;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  totalAvailableCash;
  endDate: Date;
  downloadFlg: boolean;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  public loggedInUserId;
  public loggedInUserData;
  @ViewChild("dt", { static: false }) public dt: Table;

  constructor(
    private tokenStorageService: TokenStorageService,
    private userWalletService: UserWalletService,
    private router: Router,
    private messageService: MessageService, private confirmationService: ConfirmationService, private activeroute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.loggedInUserData = this.tokenStorageService.getUser();
    this.loggedInUserId = this.loggedInUserData.userdata['id'];
    this.userId = this.activeroute.snapshot.params.id;
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.downloadFlg = false;
    
  }
  isSuperAdmin(): boolean {
    return this.loggedInUserData.userdata.rolename === 'superadmin';
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'id', 'contains');
    this.dt.filter('', 'coins', 'contains');
    this.dt.filter('', 'paymentId', 'contains');
    this.dt.filter('', 'tournamentCategory', 'contains');
    this.dt.filter('', 'platformFeeAmount', 'contains');
    this.dt.filter('', 'platformFeeRate', 'contains');
    this.dt.filter('', 'convenienceFeeAmount', 'contains');
    this.dt.filter('', 'convenienceFeeRate', 'contains');
    this.dt.filter('', 'amount', 'contains');
  }
  addNewWallet() {
    this.router.navigate(['/manage/customer/user/wallet/add/' + this.userId]);
  }

  subtractNewWallet() {
    this.router.navigate(['/manage/customer/user/wallet/subtract/' + this.userId]);
  }


  setDownloadFlag() {
    this.downloadFlg = false;
  }
  loadWalletHistory(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false&filterByUserid=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");      
    }
    if (event.filters != undefined && event.filters["id"] != undefined) {
      params += "&filterById=" + event.filters["id"].value;
    }
    if (event.filters != undefined && event.filters["tournamentCategory"] != undefined) {
      params += "&filterByTournamentCategory=" + event.filters["tournamentCategory"].value;
    }
    if (event.filters != undefined && event.filters["platformFeeAmount"] != undefined) {
      params += "&filterByPlatformFeeAmount=" + event.filters["platformFeeAmount"].value;
    }
    if (event.filters != undefined && event.filters["platformFeeRate"] != undefined) {
      params += "&filterByPlatformFeeRate=" + event.filters["platformFeeRate"].value;
    }
    if (event.filters != undefined && event.filters["convenienceFeeAmount"] != undefined) {
      params += "&filterByConvenienceFeeAmount=" + event.filters["convenienceFeeAmount"].value;
    }
    if (event.filters != undefined && event.filters["convenienceFeeRate"] != undefined) {
      params += "&filterByConvenienceFeeRate=" + event.filters["convenienceFeeRate"].value;
    }
    if (event.filters != undefined && event.filters["amount"] != undefined) {
      params += "&filterByAmount=" + event.filters["amount"].value;
    }
    if (event.filters != undefined && event.filters["paymentId"] != undefined) {
      params += "&filterByPaymentId=" + event.filters["paymentId"].value;
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.userWalletService.getUserWalletList(query).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        if (this.downloadFlg === true) {
          this.exportExcelsheet(data.data.items);
        } else {
          this.username = data.data.userInfo['name'];
          this.totalCash = data.data.totalCash;
          this.totalDeductedCash = data.data.totalDeductedCash;
          this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
          this.totalCoins = data.data.totalCoins;
          this.totalDeductedCoin = data.data.totalDeductedCoin;
          this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
          this.walletlist = data.data.items;
          this.totalRecords = data.data.totalCount;
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadWalletHistory(this.lastTableLazyLoadEvent);
  }

  exportExcelsheet(walletlist) {
    var propertiesRemove = ['tournamentplayerdata', 'contestdata', 'userId', 'status', 'created_by', 'createdBy', 'updatedby', 'disable', 'updated_at'];
    this.downloadwalletlist = walletlist;
    this.downloadwalletlist.forEach(function (item) {
      if (item.created_at != '') {
        item['created_at'] = moment(item.created_at).format('DD-MM-YYYY');
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadwalletlist);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "Wallet History");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  deleteUserWalletEntry(userWalletEntry) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to delete this entry ?',
        message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this entry ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 
      accept: () => {
        var disableStatus;
        if (userWalletEntry.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var userWalletEntryData = '{"disable":' + disableStatus + '}';
        this.userWalletService.updateUserWallet(userWalletEntry.id, userWalletEntryData).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Wallet Entry Deleted', life: 3000 });
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
          },
          err => {
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }
  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }
           addColumns() {
        this.hide = false;

    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

}
